/** Local-calendar date key (yyyy-MM-dd). Local, not UTC, so streaks match the user's day. */
export function dateKey(date: Date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseDateKey(key: string): Date {
  const [year, month, day] = key.split('-').map(Number);
  return new Date(year ?? 1970, (month ?? 1) - 1, day ?? 1);
}

export function addDays(date: Date, days: number): Date {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

export function daysBetweenKeys(from: string, to: string): number {
  const ms = parseDateKey(to).getTime() - parseDateKey(from).getTime();
  return Math.round(ms / 86_400_000);
}

/** Monday-based start of week. */
export function startOfWeek(date: Date = new Date()): Date {
  const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const offset = (start.getDay() + 6) % 7;
  return addDays(start, -offset);
}

export function lastNDateKeys(count: number, end: Date = new Date()): string[] {
  return Array.from({ length: count }, (_, i) => dateKey(addDays(end, i - count + 1)));
}

export function formatDuration(ms: number): string {
  if (ms <= 0) return '0 min';
  if (ms < 60_000) return '<1 min';
  const totalMinutes = Math.round(ms / 60_000);
  if (totalMinutes < 60) return `${totalMinutes} min`;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return minutes === 0 ? `${hours} hr` : `${hours} hr ${minutes} min`;
}

export function monthKey(date: Date = new Date()): string {
  return dateKey(date).slice(0, 7);
}
